import React from 'react';
import styles from './QuestionGroup.module.scss'

function QuestionGroup({children}) {
    return <div className={styles.QuestionGroup}>
        {children}
    </div>
}

export default QuestionGroup;
